import React, { useState } from 'react'
//import Loading from 'Components/Loading/Spinner'
import { db } from '../../../../firebase/firebase'
import { dispatch } from '../../../../store/index'
//import { getDocDownloadURL } from '../../../../firebase/storage/downloadFiles'
import actionTypes from 'config/actionTypes'
import LienearProgress from 'Components/Progress/LinearProgress'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import Paper from '@material-ui/core/Paper'
import LoadingSpinner from '@material-ui/core/CircularProgress'
import {SimpleList as List, SimpleListItem as ListItem } from 'Components/Lists/SimpleList'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import { saveAs } from 'file-saver'
import print from 'print-js'
import ButtonBoard from 'Components/Buttons/ButtonRow'
import IconSelector from 'Components/Icons/IconSelector'

const Spinner = <LoadingSpinner color='secondary'  />
const Checked = <CheckCircleIcon fontSize='large' htmlColor='green' />

const loadingText = [
	{title: 'Erstelle Abrechnungsdaten', text: '...generiere Abrechnungsdaten'},
	{title: 'Erstelle PDF Dateien', text: '...generiere PDF Dateien für Bedarf'},
	{title: 'Erstelle XML Datei für (Sparkasse)', text: '...generiere Bedarf Lastschriften'},
	//{title: 'Erstelle PDF Dateien', text: 'für die Helfer'},
	{title: 'Versende Abrechnungs Emails', text: 'an Hilfeempfänger mit E-Mail Adresse'},
	{title: 'Datein werden bereitgestellt', text: 'Abrechnung abgeschlossen!'}
]

const btnSize='small'
const AccountingResults = ({data, date})  => {

	const { requesterInfo } = data
	const handleOpenDoc = async url => {
		//const file = await fetch(url)
		window.open([url], '_blank')

		return
	}
	const handleDownloadDoc = async (url, fileName)=> {
		return saveAs(url, fileName)
	}
	const handlePrint = (fileURL) => {
	//	const blob = await fetch(url).then(r=>r.blob())
		const printOptions = print.Configuration = {
			printable: fileURL,
			type: 'pdf'
		}
		print(printOptions)
		return
	}
	const handleDownloadXML = async (url, fileName) => {
		// made blob because url direct to fileSave got a http request error on pdfs its working
		const blob = await fetch(url).then(r=>r.blob())
	
		new Promise(resolve => {
			resolve(saveAs(blob, fileName));
		  })
		  .then(result => console.log("Done downloading", result) )
		  .catch(err => console.log("Error downloading: " + err));
		return
	}
	const handleCloseResult = () => {
		dispatch({type: actionTypes.SET_ACCOUNTING_MONTH, payload: undefined})
		return db.ref('/invoiceResults/pflegekasseMembers').set({isLoading: false})
	}
/*
	const tmpDeleteInvoices = () => {
		const fsBatch = firestore.batch()
		const accountingRef = firestore.collection('accounting').doc('pflegekasse').collection('requester')
		const refs = [
			accountingRef.doc('B-3230'),
			accountingRef.doc('M-3229'),
			accountingRef.doc('B-3228'),
			accountingRef.doc('B-3227'),
			accountingRef.doc('M-3226'),
			accountingRef.doc('M-3225'),
		]
		refs.map(ref=>fsBatch.delete(ref))
		fsBatch.commit()
	}
	*/
	
	const hideCloseButton = data.text ? data.text.length<5 : false
	return (
		<Grid container spacing={1} >
			<Grid item md={6} >
				<AccountingState data={data} date={date} />
			</Grid>
			<Grid item md={6} >
				<Paper style={{padding: '1rem'}}>
					<Typography variant="h6" color="secondary">Ergebnisse</Typography>
					{requesterInfo && <div style={{marginTop: '1rem'}}>
						{requesterInfo.pdfURL
							? <PDFInfos
							
								accountingType='Hilfebedarf ohne Email'
								handleDownloadDoc={handleDownloadDoc}
								handleOpenDoc={handleOpenDoc}
								handlePrint={handlePrint}
								membersInfo={requesterInfo}
								/>
							: <NoPDFMessage memberType='Bedarf' />
						}
						{requesterInfo.xml && <div style={{marginTop: '1rem'}}>
							<XMLInfo handleDownloadXML={handleDownloadXML} xml={requesterInfo.xml} accountingType='Hilfebedarf' />
						</div>}
					</div>}
				
				</Paper>
			</Grid>
			<Grid item md={12} >
					<ButtonBoard buttons={[{ 
						title: 'Schließen',
						disabled: hideCloseButton,
						onClick:handleCloseResult,
						variant: 'outlined',
						color: 'secondary' },
						]}
					/>
			</Grid>
		</Grid>
	)
}
const NoPDFMessage = ({memberType}) =>
	<>
		<Typography color='primary' variant='subtitle1'>{`${memberType} PDF`}</Typography>
		<Typography
			component='div'
			color='secondary'
			variant='button'
		>
			{`Alle Abrechnungen wurden per Email versendet`}
		</Typography>
		<Divider />
	</>
	
const PDFInfos = ({membersInfo, handleOpenDoc, handleDownloadDoc, handlePrint, accountingType}) =>{
	const btnVariant = 'text'
	const btnColor = 'default'
	return (
		<>
			<Typography color='primary' variant='subtitle1'>{accountingType} PDF</Typography>
			<Button
				startIcon={<IconSelector iconName='Open' />}
				variant={btnVariant}
				color={btnColor}
				size={btnSize}
				onClick={()=>handleOpenDoc(membersInfo.pdfURL)}
				children='Öffnen'
			/>
			<Button
				startIcon={<IconSelector iconName='Save' />}
				variant={btnVariant}
				color={btnColor}
				size={btnSize}
				onClick={()=>handleDownloadDoc(membersInfo.pdfURL, membersInfo.fileName)} 
				children='Speichern'
			/>
			<Button
				startIcon={<IconSelector iconName='Print' />}
				children='Drucken'
				variant={btnVariant}
				color={btnColor}
				size={btnSize}
				onClick={()=>handlePrint(membersInfo.pdfURL)}

			/>
			<Divider />
		</>
	)
}
const XMLInfo = ({handleDownloadXML, xml, accountingType}) => {

	const btnVariant='text'
	const btnColor='default'
	return (
		<>
			<Typography color='primary' variant='subtitle1'>{accountingType} XML (Sparkasse)</Typography>
			<Button
				startIcon={<IconSelector iconName='Save' />}
				variant={btnVariant}
				color={btnColor}
				size={btnSize}
				onClick={()=>handleDownloadXML(xml.url, xml.fileName)}
				children='Speichern'
			/>
		</>
	)
}


const AccountingState = ({data: {text}, date}) => {
	const [loadingDone, setLoadingDone ] = useState(false)
	let loadingState

	let progress = text && text.length>=2 ? (20*(text.length-1)) : 0
	let progressBuffer = progress+20
	if(loadingDone)
		progress = 100
	return (
		<Paper style={{padding: '1rem'}}>
			<Typography variant="h6" color="secondary">Fortschrit {moment(date).format('MMMM YYYY')}</Typography>
			<LienearProgress
				variant="buffer"
				value={progress}
				valueBuffer={progressBuffer}
				color={progress<=99 ? 'secondary' : 'primary'}
			/>
			<List dense={true}>
				{text && text.map((step, i)=>{
					const isDone = step==='done'
					const isLast = text.length===i+1
					if(isDone) {
						if(!loadingDone)
							setLoadingDone(true)
							loadingText[i]={title: 'Abgechlossen', text: 'Abrechnung abgeschlossen'}
					}
					loadingState=isDone
						? Checked
						: isLast
							? Spinner
							: Checked
					return <ListItem
								onItemClick={()=>{}}
								title={loadingText[i].title}
								text={loadingText[i].text}
								key={i}
								icon={loadingState}
								/>
				})}
			</List>
		</Paper>
	)
}

export default AccountingResults
